import { useTranslation } from "react-i18next";
import { Facebook, Instagram, MessageCircle, Share2 } from "lucide-react";

const ShareButtons = ({ property, className = "" }) => {
  const { t } = useTranslation();
  
  const shareUrl = typeof window !== 'undefined' 
    ? window.location.href 
    : `https://ikonicdeals.com/propiedad/${property?.slug || property?.id}`;
  
  const shareTitle = property?.name || "Propiedad en Ikonic Deals";
  const shareText = `${shareTitle} - ${property?.zone || ""}, ${property?.department || "Guatemala"}`;
  
  const shareLinks = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${shareText}\n\n${shareUrl}`)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`,
    // Instagram doesn't support direct URL sharing, so we copy to clipboard with a prompt
    instagram: null
  };

  const handleInstagramShare = async () => {
    try {
      await navigator.clipboard.writeText(`${shareText}\n\n${shareUrl}`);
      // Show alert with instructions since Instagram doesn't support web sharing
      alert(t('share.instagramCopied', 'Texto copiado! Abre Instagram y pégalo en tu historia o publicación.'));
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleShare = (platform) => {
    if (platform === 'instagram') {
      handleInstagramShare();
    } else {
      window.open(shareLinks[platform], '_blank', 'width=600,height=400');
    }
  };

  return (
    <div className={`${className}`}>
      <p className="text-[#A3A3A3] text-sm mb-3 flex items-center gap-2">
        <Share2 size={16} />
        {t('common.share')}
      </p>
      <div className="flex gap-2">
        {/* WhatsApp */}
        <button
          onClick={() => handleShare('whatsapp')}
          className="flex items-center justify-center w-10 h-10 bg-[#25D366] hover:bg-[#20BD5A] rounded-full transition-colors"
          title="Compartir en WhatsApp"
          data-testid="share-whatsapp"
        >
          <MessageCircle size={18} className="text-white" />
        </button>
        
        {/* Facebook */}
        <button
          onClick={() => handleShare('facebook')}
          className="flex items-center justify-center w-10 h-10 bg-[#1877F2] hover:bg-[#166FE5] rounded-full transition-colors"
          title="Compartir en Facebook"
          data-testid="share-facebook"
        >
          <Facebook size={18} className="text-white" />
        </button>
        
        {/* Twitter/X */}
        <button
          onClick={() => handleShare('twitter')}
          className="flex items-center justify-center w-10 h-10 bg-black hover:bg-[#333] border border-white/20 rounded-full transition-colors"
          title="Compartir en X (Twitter)"
          data-testid="share-twitter"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 text-white fill-current">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </button>
        
        {/* Instagram */}
        <button
          onClick={() => handleShare('instagram')}
          className="flex items-center justify-center w-10 h-10 bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] hover:opacity-90 rounded-full transition-opacity"
          title="Compartir en Instagram"
          data-testid="share-instagram"
        >
          <Instagram size={18} className="text-white" />
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
